(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCategoryCarousels() {
      document.querySelectorAll('[data-cat-carousel]').forEach(function (root) {
        var track = root.querySelector('[data-cat-track]');
        var prevBtn = root.querySelector('[data-cat-prev]');
        var nextBtn = root.querySelector('[data-cat-next]');
        if (!track) return;

        function scrollByItem(direction) {
          var item = track.querySelector('[data-cat-item]');
          var gap = parseFloat(window.getComputedStyle(track).columnGap || '0') || 0;
          var amount = item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
          var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollBy({ left: direction * amount, behavior: reduceMotion ? 'auto' : 'smooth' });
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', function () {
            scrollByItem(-1);
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            scrollByItem(1);
          });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCategoryCarousels);
    } else {
      initCategoryCarousels();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getRoot(el) {
      return el.closest('[data-collection-tabs]');
    }

    function setBusy(root, busy) {
      var grid = root.querySelector('[data-tab-grid]');
      if (grid) grid.setAttribute('aria-busy', busy ? 'true' : 'false');
    }

    function setActiveTrigger(root, trigger) {
      var triggers = root.querySelectorAll('[data-tab-trigger]');
      triggers.forEach(function (t) {
        var active = t === trigger;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.setAttribute('tabindex', active ? '0' : '-1');
      });
    }

    function activateTab(trigger) {
      var root = getRoot(trigger);
      if (!root || !window.theme || typeof window.theme.fetchSection !== 'function') return;
      var sectionId = root.getAttribute('data-section-id');
      var handle = trigger.getAttribute('data-collection-handle') || '';

      setActiveTrigger(root, trigger);
      setBusy(root, true);

      var url = new URL(window.location.href);
      if (handle) {
        url.searchParams.set('tab', handle);
      } else {
        url.searchParams.delete('tab');
      }

      window.theme
        .fetchSection(sectionId, url.toString())
        .then(function (doc) {
          var freshGrid = doc.querySelector('[data-tab-grid]');
          var currentGrid = root.querySelector('[data-tab-grid]');
          if (freshGrid && currentGrid) {
            currentGrid.replaceWith(freshGrid);
          } else {
            setBusy(root, false);
          }
          window.history.replaceState({}, '', url.toString());
        })
        .catch(function () {
          setBusy(root, false);
        });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-tab-trigger]');
      if (!trigger) return;
      event.preventDefault();
      if (trigger.getAttribute('aria-selected') === 'true') return;
      activateTab(trigger);
    });

    document.addEventListener('keydown', function (event) {
      var keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
      if (keys.indexOf(event.key) === -1) return;
      var trigger = event.target.closest('[data-tab-trigger]');
      if (!trigger) return;
      var root = getRoot(trigger);
      if (!root) return;
      var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-tab-trigger]'));
      var index = triggers.indexOf(trigger);
      var nextIndex = index;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % triggers.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + triggers.length) % triggers.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = triggers.length - 1;
      if (nextIndex !== index) {
        event.preventDefault();
        triggers[nextIndex].focus();
        activateTab(triggers[nextIndex]);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    function initCollection(root) {
      var sectionId = root.getAttribute('data-section-id');

      function applyUrl(url) {
        var theme = window.theme || {};
        if (typeof theme.fetchSection !== 'function') {
          window.location.href = url;
          return;
        }
        theme.fetchSection(sectionId, url).then(function (doc) {
          var fresh = doc.querySelector('[data-collection-section]');
          if (fresh) {
            var top = root.getBoundingClientRect().top + window.scrollY - 24;
            root.replaceWith(fresh);
            initCollection(fresh);
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
          window.history.pushState({}, '', url);
          var dialog = document.getElementById('FilterDrawer-' + sectionId);
          if (dialog && dialog.open) theme.closeDialog(dialog);
        });
      }

      var filterForm = root.querySelector('[data-filter-form]');
      var applyButton = document.querySelector('[data-filter-apply]');
      function submitFilters(event) {
        if (event) event.preventDefault();
        var params = new URLSearchParams(new FormData(filterForm));
        var url = window.location.pathname + '?' + params.toString();
        applyUrl(url);
      }
      if (filterForm) {
        filterForm.addEventListener('submit', submitFilters);
      }
      if (applyButton) {
        applyButton.addEventListener('click', submitFilters);
      }

      var sortSelect = root.querySelector('[data-sort-select]');
      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sortSelect.value);
          applyUrl(url.toString());
        });
      }

      root.querySelectorAll('[data-collection-link]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          applyUrl(link.href);
        });
      });
    }

    function init() {
      document.querySelectorAll('[data-collection-section]').forEach(initCollection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    window.addEventListener('popstate', function () {
      window.location.reload();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-addresses"]) return;
  try {
    
  (function () {
    function wireCountryProvince() {
      if (!window.Shopify || !window.Shopify.CountryProvinceSelector) return;
      var countrySelects = document.querySelectorAll('[data-address-country-select]');
      countrySelects.forEach(function (countrySelect) {
        var form = countrySelect.closest('form');
        if (!form || !countrySelect.id) return;
        var provinceSelect = form.querySelector('[data-address-province-select]');
        var provinceWrapper = form.querySelector('[data-address-province-wrapper]');
        if (!provinceSelect || !provinceSelect.id) return;
        new window.Shopify.CountryProvinceSelector(countrySelect.id, provinceSelect.id, {
          hideElement: provinceWrapper ? provinceWrapper.id : null
        });
      });
    }

    if (document.readyState === 'complete') {
      wireCountryProvince();
    } else {
      window.addEventListener('load', wireCountryProvince);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-login"]) return;
  try {
    
  (function () {
    var showBtn = document.getElementById('ShowRecoverPassword');
    var hideBtn = document.getElementById('HideRecoverPassword');
    var loginWrap = document.getElementById('LoginFormWrapper');
    var recoverWrap = document.getElementById('RecoverPasswordFormWrapper');
    if (!showBtn || !hideBtn || !loginWrap || !recoverWrap) return;

    showBtn.addEventListener('click', function () {
      loginWrap.hidden = true;
      recoverWrap.hidden = false;
      showBtn.setAttribute('aria-expanded', 'true');
      var input = recoverWrap.querySelector('input');
      if (input) input.focus();
    });

    hideBtn.addEventListener('click', function () {
      recoverWrap.hidden = true;
      loginWrap.hidden = false;
      showBtn.setAttribute('aria-expanded', 'false');
      showBtn.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function formatMoney(cents) {
      var theme = window.theme || {};
      if (typeof theme.formatMoney === 'function') {
        return theme.formatMoney(cents, theme.moneyFormat);
      }
      return cents;
    }

    function initGallery(root) {
      var mainMedia = root.querySelector('[data-main-media]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-media-item]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));

      function setActive(index) {
        if (index < 0 || index >= items.length) return;
        items.forEach(function (item, i) {
          item.classList.toggle('is-active', i === index);
        });
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === index);
          thumb.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      function indexForMediaId(mediaId) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].getAttribute('data-media-id') === String(mediaId)) return i;
        }
        return -1;
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          setActive(i);
        });
        thumb.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            var next = event.key === 'ArrowRight' ? (i + 1) % thumbs.length : (i - 1 + thumbs.length) % thumbs.length;
            thumbs[next].focus();
            setActive(next);
          }
        });
      });

      if (mainMedia && items.length > 1 && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
                var idx = items.indexOf(entry.target);
                if (idx > -1) setActive(idx);
              }
            });
          },
          { root: mainMedia, threshold: 0.6 }
        );
        items.forEach(function (item) {
          observer.observe(item);
        });
      }

      root.__gallerySetActiveByMediaId = function (mediaId) {
        var idx = indexForMediaId(mediaId);
        if (idx > -1) setActive(idx);
      };
    }

    function initVariants(root) {
      var dataEl = root.querySelector('[data-variant-json]');
      var variants = [];
      try {
        variants = JSON.parse(dataEl ? dataEl.textContent : '[]');
      } catch (e) {
        variants = [];
      }
      if (!variants.length) return;

      var optionsWrap = root.querySelector('[data-product-options]');
      var optionGroups = optionsWrap ? Array.prototype.slice.call(optionsWrap.querySelectorAll('[data-option-index]')) : [];
      var selectEl = root.querySelector('[data-product-select]');
      var priceWrap = root.querySelector('[data-product-price]');
      var addButton = root.querySelector('[data-add-to-cart]');
      var addText = root.querySelector('[data-add-text]');
      var inventoryWrap = root.querySelector('[data-inventory]');
      var lowStockTemplate = root.getAttribute('data-low-stock-template') || '';
      var strings = (window.theme && window.theme.strings) || {};

      function currentSelection() {
        return optionGroups.map(function (group) {
          var active = group.querySelector('[data-option-value].is-active');
          return active ? active.getAttribute('data-value') : null;
        });
      }

      function findVariant(selection) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var opts = [v.option1, v.option2, v.option3];
          var matches = true;
          for (var j = 0; j < selection.length; j++) {
            if (selection[j] !== null && opts[j] !== selection[j]) {
              matches = false;
              break;
            }
          }
          if (matches) return v;
        }
        return null;
      }

      function renderPrice(variant) {
        if (!priceWrap) return;
        var regularLabel = priceWrap.getAttribute('data-label-regular') || '';
        var saleLabel = priceWrap.getAttribute('data-label-sale') || '';
        if (!variant) {
          priceWrap.className = 'product__price price price--sold-out';
          return;
        }
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        var html = '<span class="visually-hidden">' + regularLabel + '</span>';
        html += '<span class="price__current">' + formatMoney(variant.price) + '</span>';
        if (onSale) {
          html += '<span class="visually-hidden">' + saleLabel + '</span>';
          html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
        }
        priceWrap.className = 'product__price price' + (onSale ? ' price--on-sale' : '') + (!variant.available ? ' price--sold-out' : '');
        priceWrap.innerHTML = html;
      }

      function renderInventory(variant) {
        if (!inventoryWrap) return;
        inventoryWrap.innerHTML = '';
        if (!variant) return;
        var tracked = variant.inventory_management;
        var qty = variant.inventory_quantity;
        if (tracked && typeof qty === 'number' && qty > 0 && qty <= 5) {
          var p = document.createElement('p');
          p.className = 'product__stock product__stock--low';
          p.textContent = lowStockTemplate.replace('__COUNT__', qty);
          inventoryWrap.appendChild(p);
        }
      }

      function renderAvailability(variant) {
        if (!addButton || !addText) return;
        if (!variant) {
          addText.textContent = strings.unavailable || addText.textContent;
          addButton.setAttribute('aria-disabled', 'true');
          return;
        }
        if (variant.available) {
          addText.textContent = strings.addToCart || addText.textContent;
          addButton.removeAttribute('aria-disabled');
        } else {
          addText.textContent = strings.soldOut || addText.textContent;
          addButton.setAttribute('aria-disabled', 'true');
        }
      }

      function updateUrl(variant) {
        if (!variant || !window.history || !window.history.replaceState) return;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }

      function setFormId(variant) {
        if (!selectEl) return;
        if (variant) {
          selectEl.value = variant.id;
        }
        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
      }

      function onVariantChange() {
        var variant = findVariant(currentSelection());
        renderPrice(variant);
        renderInventory(variant);
        renderAvailability(variant);
        updateUrl(variant);
        if (selectEl && selectEl.tagName === 'SELECT') {
          if (variant) selectEl.value = variant.id;
        }
        if (variant && variant.featured_media && root.__gallerySetActiveByMediaId) {
          root.__gallerySetActiveByMediaId(variant.featured_media.id);
        }
      }

      optionGroups.forEach(function (group) {
        var buttons = Array.prototype.slice.call(group.querySelectorAll('[data-option-value]'));
        buttons.forEach(function (button) {
          button.addEventListener('click', function () {
            buttons.forEach(function (b) {
              b.classList.remove('is-active');
              b.setAttribute('aria-selected', 'false');
            });
            button.classList.add('is-active');
            button.setAttribute('aria-selected', 'true');
            onVariantChange();
          });
        });
      });

      if (selectEl && selectEl.tagName === 'SELECT' && !optionGroups.length) {
        selectEl.addEventListener('change', function () {
          var variant = null;
          for (var i = 0; i < variants.length; i++) {
            if (String(variants[i].id) === selectEl.value) {
              variant = variants[i];
              break;
            }
          }
          renderPrice(variant);
          renderInventory(variant);
          renderAvailability(variant);
          updateUrl(variant);
        });
      }
    }

    function initProduct(root) {
      initGallery(root);
      initVariants(root);
    }

    function init() {
      document.querySelectorAll('[data-product-root]').forEach(initProduct);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function renderInto(root, html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var freshGrid = doc.querySelector('[data-related-grid]');
      var grid = root.querySelector('[data-related-grid]');
      var freshHasProducts = freshGrid && freshGrid.children.length > 0;
      if (freshGrid && grid) {
        grid.innerHTML = freshGrid.innerHTML;
      }
      root.hidden = !freshHasProducts;
    }

    function initRelated(root) {
      var baseUrl = root.getAttribute('data-url');
      var productId = root.getAttribute('data-product-id');
      var limit = root.getAttribute('data-limit') || 4;
      var sectionId = root.getAttribute('data-section-id');
      if (!baseUrl || !productId || !sectionId) return;

      var url = baseUrl + '?section_id=' + encodeURIComponent(sectionId) + '&product_id=' + encodeURIComponent(productId) + '&limit=' + encodeURIComponent(limit) + '&intent=related';

      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error(response.statusText);
          return response.text();
        })
        .then(function (html) {
          renderInto(root, html);
        })
        .catch(function () {
          root.hidden = true;
        });
    }

    function init() {
      document.querySelectorAll('[data-related-products]').forEach(initRelated);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
